module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_cuad_19.b21679e8.png";